import { toast } from 'react-toastify';

/** Single app-wide toast container (see App.js). Always pass this containerId. */
export const APP_TOAST_CONTAINER_ID = 'app';

export const showAppToast = (type, message, options = {}) => {
	const normalized = message != null ? String(message).trim() : '';
	if (!normalized) return;

	const mergedOptions = {
		containerId: APP_TOAST_CONTAINER_ID,
		...(options && typeof options === 'object' && !Array.isArray(options) ? options : {}),
	};

	const toastType = String(type || 'success').toLowerCase();
	if (toastType === 'error') {
		toast.error(normalized, mergedOptions);
	} else if (toastType === 'info') {
		toast.info(normalized, mergedOptions);
	} else if (toastType === 'warning' || toastType === 'warn') {
		toast.warn(normalized, mergedOptions);
	} else {
		toast.success(normalized, mergedOptions);
	}
};
